import type { LayerRaw } from '@tsyl/karonte/lib/types/layers'

const elevationSouthAmerica: LayerRaw = {
  id: 'elevation_layer',
  type: 'WMS',
  url: '/wfas-proxy/geoserver/wms',
  title: {
    'en-US': 'Elevation',
    'pt-BR': 'Elevação',
    'es-ES': 'Elevación',
    'fr-FR': 'Élévation'
  },
  zindex: 1,
  opacity: 0.5,
  active: true,
  activeTarget: 'visibility',
  enabled: false,
  legend: {
    title: 'n/a'
  },
  customProperties: { group: 'reference' },
  sublayers: [
    {
      id: 'wfas:SouthAmerica_30arcsec_DEM_GMTED2010_Masked',
      visible: true,
      legend: {
        title: {
          'en-US': 'Elevation',
          'pt-BR': 'Elevação',
          'es-ES': 'Elevación',
          'fr-FR': 'Élévation'
        },
        items: [
          {
            color: '#ff0000',
            icon: 'mdi-close',
            text: {
              'en-US': 'No Data',
              'pt-BR': 'Sem dados',
              'es-ES': 'Sin Datos',
              'fr-FR': 'Aucune donnée'
            }
          },
          {
            type: 'ramp',
            items: [
              {
                color: '#FFFFFF',
                ratio: 0.01,
                text: {
                  'en-US': 'Minimum',
                  'pt-BR': 'Mínima',
                  'es-ES': 'Mínima',
                  'fr-FR': 'Minimum'
                }
              },
              {
                text: '0-500m',
                color: '#B2182B',
                ratio: 0.1
              },
              {
                text: '>500-1000m',
                color: '#EF8A62',
                ratio: 0.2
              },
              {
                text: '>1000-1500m',
                color: '#FDDBC7',
                ratio: 0.3
              },
              {
                text: '>1500-2000m',
                color: '#F7F7F7',
                ratio: 0.4
              },
              {
                text: '>2000-2500m',
                color: '#D1E5F0',
                ratio: 0.5
              },
              {
                text: '>2500-3000m',
                color: '#67A9CF',
                ratio: 0.6
              },
              {
                text: '>3000-3500m',
                color: '#2166AC',
                ratio: 0.7
              },
              {
                text: '>3500-4000m',
                color: '#053061',
                ratio: 0.8
              },
              {
                text: '>4000-4500m',
                color: '#252525',
                ratio: 0.9
              },
              {
                text: '>4500m',
                color: '#000000',
                ratio: 1
              }
            ]
          }
        ]
      }
    }
  ],
  icon: 'mdi-barley'
}

export default elevationSouthAmerica
